import {AfterViewInit, ChangeDetectorRef, Component, inject, model, OnInit, signal, ViewChild} from '@angular/core';
import {ButtonComponent, ButtonOptions, FormComponent, ModalComponent, ModalOptions} from "@shared/components";
import {
  AbstractControl,
  FormControl,
  FormGroup,
  FormsModule,
  NgForm,
  ReactiveFormsModule, ValidationErrors,
  ValidatorFn,
  Validators
} from "@angular/forms";
import {NgOptimizedImage} from "@angular/common";
import {TextAreaComponent, TextAreaOptions} from "@shared/components/text-area/text-area.component";
import {APIService, DataService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {HTTPMethods, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';
import {assets, FILTER_TEXT_FOR_TEXTAREA} from '@core/constants';
import {ResponseSingle} from '@core/classes/other/response';
import {AutonomyInvalidity} from '@core/classes/tables/autonomy-invalidity';

@Component({
  selector: 'ncp-add-autonomy-invalidity',
  imports: [
    ButtonComponent,
    FormsModule,
    ModalComponent,
    NgOptimizedImage,
    TextAreaComponent,
    ReactiveFormsModule
  ],
  templateUrl: './add-autonomy-invalidity.component.html',
  styleUrl: './add-autonomy-invalidity.component.scss',
})
export class AddAutonomyInvalidityComponent implements OnInit, AfterViewInit {
  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('aiFrm') protected autonomyFormEl?: NgForm;
  @ViewChild('addAutonomyButton') public addAutonomyButton!: ButtonComponent;

  @ViewChild('invalidityTxt') public invalidityTxt!: TextAreaComponent;

  protected readonly toastService = inject(ToastService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  private apiService = inject(APIService);
  private patientService = inject(PatientService);
  private dataService = inject(DataService);

  protected data = model<any>();

  private _params = {};
  protected form: FormGroup = new FormGroup({
    description: new FormControl<string>('', [Validators.required]),
  }, {
    validators: [this.formValidator()]
  });

  formValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let errors: ValidationErrors | null = {};

      let description = (control as FormGroup).controls['description'];

      if(description.value === undefined || description.value === null || description.value === '') {
        description.setErrors({ai_descriptionInvalid: true});
        errors['ai_descriptionInvalid'] = true;
      }

      return Object.keys(errors).length > 0 ? errors : null;
    }
  }

  getFormControl = (name: string) => {
    return this.form.get(name) as FormControl;
  }

  public btnAIOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'aiBtn',
      tooltip: 'add_autonomy',
    })
  );

  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.form,
      form: FormComponent,
      title: 'add_autonomy',
      options: {
        animation: true,
        size: 'xl',
        fullscreen: "lg",
        backdrop: 'static',
        keyboard: false,
      },
      onClose: () => {this.onFormReset()}
    })
  );

  protected autonomyInvalidityOptions = signal<TextAreaOptions>(
    new TextAreaOptions({
      id: 'autonomy_invalidity',
      label: {
        text: 'autonomy_invalidity',
      },
      name: 'autonomy_invalidity',
      formControl: this.getFormControl('description'),
      initialValue: '',
      pattern: FILTER_TEXT_FOR_TEXTAREA
    })
  );

  ngOnInit() {
    this.btnAIOptions().onClick = (event) => {
      this.mod.options().onReset = this.onFormReset;
      this.addAutonomyButton.blur();
      this.mod.open();
    };

    this.modOptions().onSave = this.onSave;
  }

  onFormReset = () => {
    console.log('on reset form');
    this.form.reset();
  }

  ngAfterViewInit(): void {

  }

  onSave = () => {
    this.autonomyFormEl?.ngSubmit.emit();
  }

  onFormSubmit = () => {
    if(this.form.invalid) {
      console.log('this.form.is.invalid');
      return;
    }

    this.modOptions().disableOnSave = true;
    let body = {
      description: (this.form.get('description') as FormControl).value,
      status: 1,
      version_id: this.patientService.version!.new,
    }

    this.apiService.call({
      path: '/autonomy-invalidity',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.POST,
      body: body
    })?.subscribe((res: ResponseSingle<AutonomyInvalidity>) => {
      if(res && res.status?.toString() === '1') {
        let data = this.data()?.tblOptions().data
        data.unshift(res.data)
        if (this.data && this.data() && this.data().tbl && this.data().tbl.tableData) {
          this.data()!.tbl!.tableData! = data;
        }
        this.mod.close();
      }
    })
  }

  protected readonly assets = assets;
}
